import axios from "@/libs/request";

// 进入服务器上报
export const enterServerReport = (data) => axios.request({ url: "/notice/normalGame", data, unHint: true });
// 角色升级上报
export const roleUpdateReport = (data) => axios.request({ url: "/data/role/level-up", data, unHint: true });
// 广告数据上报
export const clickReport = (data) => axios.request({ url: "/lead/strongLead/click", data, unHint: true });
// 创角日志上报
export const roleCreateReport = (data) => axios.request({ url: "/data/role-create-page", data, unHint: true });
// 创角成功日志上报
export const roleCreateSuccessReport = (data) => axios.request({ url: "/data/role-create-succeed", data, unHint: true });
// 进入游戏日志上报
export const enterGameReport = (data) => axios.request({ url: "/data/enter-game", data, unHint: true });
// 激活上报 (ios买包用)
export const attributeReport = (data) => axios.request({ url: "/data/attribute", data, unHint: true });
// 全局错误上报
export const globalErrReport = (data) => axios.request({ url: "/data/exception", data, unHint: true })